const initLottieAnimation = async () => {
    const {default: Lottie} = await import('lottie-web');
    const elements = document.querySelectorAll('.lottie');

    elements.forEach((elements) => {
        if (elements) {
            const isLoop = elements.dataset.loop === 'true';
            const animation = Lottie.loadAnimation({
                container: elements,
                renderer: 'svg',
                loop: isLoop,
                autoplay: isLoop,
                path: elements.dataset.animPath
            });

            if (! isLoop) {
                animation.addEventListener('DOMLoaded', () => {
                    animation.playSegments([0, 59], true);
                });

                animation.addEventListener('complete', () => {
                    animation.playSegments([60, 180], false);
                });
            }

            if (document.querySelector('#admin')) {
                setTimeout(() => {
                    document.dispatchEvent(new Event('MasonryReload'));
                }, 300);
            }
        }
    });
}

export default class LottieAnimation {
    static init() {
        initLottieAnimation();
    }
}
